<template>
  <el-dialog :custom-class="isframe?'max-dialog1256':'max-dialog'" title="修改商品" :visible.sync="dialogFormVisible" center
             :close-on-click-modal="false" :append-to-body="true">
    <div class="search-content">
      <el-select v-model="cangkucode" @change="changeCangKu" v-if="isframe" style="width: 130px;display: block;margin: auto;float: left;margin-left: 30px;" size="mini">
      <el-option v-for="item in jxcstoreData" :key="item.cangkucode" size="mini" :label="item.cangkuname" :value="item.cangkucode"></el-option>
      </el-select>
      <CommonTree ref="treeSeed" :defineDataSource="true" @bindData="bindData"
                                             v-if="isframe" :inputSize="'mini'" :placeholder="'请选择品牌'"
                                             :isShowCheckBox="false" :treeWidth="550"
                                             style="width: 200px;display: block;margin: auto;float: left;margin-left: 30px;"
                                             :onlyShowGroupType="false" :needTopNode="false" :onlySelectChild="true"
                                             :treeHeight="500" :searchText="seedname"
                                             @check="checktree1"></CommonTree>
      <el-button type="success" @click.stop.prevent="addGood()" size="mini" v-if="seedcodeData.length>0">选择</el-button>
      <span v-if="isframe"> 总数：{{totalnumber}}</span>
      <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;top: 15px;" class="query-table" v-if="isframe" >
        <template v-for="(row,index) in DataTable">
        <tr v-if="index==0">
          <td style="text-align: center">商品编号</td>
          <td style="text-align: center">商品名称</td>
          <td style="text-align: center">规格</td>
          <td style="text-align: center">型号</td>
          <td  style="text-align: center;width: 120px" >数量</td>
        </tr>
        <tr >
          <td style="text-align: center">{{row.seedcode}}</td>
          <td style="text-align: center">{{row["产品名称"]}}</td>
          <td style="text-align: center">{{row["型号"]}}</td>
          <td style="text-align: center">{{row["规格"]}}</td>
          <td  style="text-align: center;width: 120px" >  <el-input-number :value='row["数量"]' @input='val => row["数量"] = val' @change="subTable" auto-complete="off" size="mini" width="100%" :controls="false" :min="0"></el-input-number></td>
        </tr>
        </template>
      </table>
      <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;margin-bottom: 15px" class="query-table" v-else v-for="(row,index) in DataTable">
        <tr >
          <td
            v-if="item.isshow==1"
            style="text-align: center"
            v-for="item in row">{{item.name}}
          </td>
          <td
            v-if="item.isshow==2"
            style="text-align: center;width: 90px"
            v-for="item in row">{{item.name}}
          </td>
        </tr>
        <tr>
          <td
            v-if="item.isshow==1"
            style="text-align: center"
            v-for="item in row">{{item.value}}
          </td>
          <td
            v-if="item.isshow==2"
            style="text-align: center"
            v-for="item in row">
            <el-select v-model="item.value" placeholder="请选择" style="width: 90%" size="mini" v-if="item.name=='R/L'">
              <el-option  label="" value=""></el-option>
              <el-option  label="R" value="R"></el-option>
              <el-option  label="L" value="L"></el-option>
            </el-select>
            <el-input v-model="item.value" auto-complete="off" size="mini" width="100%" v-else></el-input>
          </td>
        </tr>
      </table>
      <div style="float: left;width: 280px;text-align: right" v-for="item in parameter">{{item.name}}：<el-input v-model="item.value" auto-complete="off" size="mini" style="width: 80px"></el-input></div>
    </div>
    <div slot="footer" class="dialog-footer no-print">
      <el-button @click="dialogFormVisible=false">取 消</el-button>
      <el-button type="primary" @click="saveData">保 存</el-button>
      <BatchBuyFormProperties ref="batchBuyFormProperties" @afterSelectCode="afterSelectCode"></BatchBuyFormProperties>
      <MakeInventoryFrameAdd ref="MakeInventoryFrameAdd" @afterSelect="afterSelect"></MakeInventoryFrameAdd>
    </div>
  </el-dialog>
</template>

<script>
  import {getJxcformdetailGetList,updatePackagesize,updateGoodsnum} from '@/api/set/csagreement'
  import {getPrice} from '@/api/set/goodsprice';
  import {getGoodsTree, listgoodsframe} from '@/api/set/jxcgooddetail';
  import {cusandptbyind} from '@/api/set/jxcstore';
  import BatchBuyFormProperties from '../buyagreement/BatchBuyFormProperties'
  import MakeInventoryFrameAdd from '../../warehouse/MakeInventoryFrameAdd';
  export default {
    name: "editPackage",
    data() {
      return {
        details: [],
        DataTable: [],
        parameter: [],
        erpserial:'',
        canEditRL: false,
        BookContent: [],
        controlData: {},
        noAdd: true,
        noRL: true,
        seedcode: '',
        seedname: '',
        cangkucode:'',
        cangkuname:'',
        seedcodeData:[],
        jxcstoreData:[],
        dialogFormVisible: false,
        isframe: false,
        totalnumber:0,
      }
    },
    methods: {
      changeCangKu() {
        this.jxcstoreData.forEach(o => {
          if (o.cangkucode == this.cangkucode) {
            this.cangkuname = o.cangkuname
          }
        })
      },
      bindData() {
        this.$refs.treeSeed.bindData(() => {
          return getGoodsTree({filltemplates: '80', hideseed: '1'})
        })
      },
      subTable(){
        this.totalnumber=0;
        for(let i in this.DataTable){
          this.totalnumber+=parseInt(this.DataTable[i]["数量"]);
        }
      },
      afterSelect(arr) {
        var selectArr = []
        for (var i in arr) {
          selectArr.push({
            seedcode: arr[i].seedcode,
            seedname: arr[i].seedname,
            color: arr[i].C,
            model: arr[i].M,
            categorycode: arr[i].categorycode,
            totalnumber: arr[i].P
          });
        }
        this.afterSelectCode(selectArr);
      },
      //选择商品之后执行
      afterSelectCode(arr) {
        console.log(arr)
        for (let i in arr) {
          let biaoji = 0
          for (let j in this.DataTable) {
            //判读该商品是否属于
            if (this.DataTable[j].seedcode == arr[i].seedcode && this.DataTable[j]["型号"] == arr[i].model&& this.DataTable[j]["规格"] == arr[i].color) {
              biaoji = 1
              this.DataTable[j]["数量"] =parseInt(this.DataTable[j]["数量"])+parseInt(arr[i].totalnumber);
              break
            }
          }
          if (biaoji == 0) {
            this.DataTable.push({
              unitguid:"",
              seedcode: arr[i].seedcode,
              "产品名称": arr[i].seedname,
              "规格": arr[i].color,
              "型号": arr[i].model,
              categorycode: arr[i].categorycode,
              "数量": parseInt(arr[i].totalnumber),
              formproperty: '[{}]',
              packagesize: '{"M":"' + arr[i].model + '","C":"' + arr[i].color + '"}'
            })
          }
        }
        this.subTable();
      },
      //选择类别后执行的方法
      checktree1(guids, names, arr) {
        this.seedcode = guids
        this.seedname = names
        this.seedcodeData = []
        if(!this.seedcode){
          return;
        }

        listgoodsframe({
          categorycode: this.seedcode,
          filltemplate: '80',
        }).then(response => {
          this.seedcodeData = response.data.obj
          if (this.seedcodeData.length > 0) {
            this.addGood();
          } else {
            this.$message({
              message: '该系列没有镜架商品',
              type: 'warning'
            })
            return
          }
        }).catch((error) => {
          console.log(error)
        });

      },
      addGood(){
        this.$refs.MakeInventoryFrameAdd.show(this.seedcodeData,{cangkucode:this.cangkucode,cangkuname:this.cangkuname})
      },
      getPackagesize(Packagesize) {
        if (!Packagesize || Packagesize == '') {
          return '';
        }
        var ps = JSON.parse(Packagesize);
        var rl = '';
        if (ps.type)
          rl = ps.type + '，';

        return rl + 'S：' + ps.Y + ' ， C：' + ps.X;
      },
      saveData() {
        if(this.isframe){
          this.saveDataframe();
          return;
        }
        var updateArr = []
        for (let i in this.details) {
          var unitguid = this.details[i].unitguid
          if (!this.details[i].packagesize || !this.details[i].formproperty) {
            continue;
          }

          var packagesize = this.details[i].packagesize ? JSON.parse(this.details[i].packagesize) : null;
          var formproperty = JSON.parse(this.details[i].formproperty)[0]

          for (let j in this.DataTable) {
            var pk = false;
            for (let m in this.DataTable[j]) {
              if (this.DataTable[j][m].name == 'unitguid' && this.DataTable[j][m].value == unitguid) {
                pk = true
                break;
              }
            }
            if (pk) {//需要更新
              var seedcode = ''
              for (let m in this.DataTable[j]) {
                var item = this.DataTable[j][m];
                if (item.name == '产品编码') {
                  seedcode = item.value;
                }

                if (item.isshow == 2) {
                  ////////////////////////////////////////////
                  if (item.name == '柱镜') {//X
                    packagesize.X = parseFloat(item.value).toFixed(2);
                  } else if (item.name == '球镜') {//Y
                    packagesize.Y = parseFloat(item.value).toFixed(2);
                  } else if (item.name == 'R/L') {//type
                    if (packagesize.type) {//有type的 必填
                      if (item.value) {
                        packagesize.type = item.value;
                      } else {
                        this.$message({
                          message: 'R/L必填！',
                          type: 'error',
                        })
                        return;
                      }
                    }
                    if (item.value)
                      formproperty.type = item.value;
                    else if (formproperty.type) {
                      formproperty.type = '';
                    }
                  } else {
                    var colm = item.name;
                    if (item.name == '轴位') {
                      colm = 'A'
                    }
                    if (formproperty.hasOwnProperty(colm)) {
                      formproperty[colm] = item.value;
                    } else {
                      if (item.name == 'ADD' && item.value) {
                        formproperty['ADD'] = item.value;
                      } else if (item.name == '通道' && item.value) {
                        formproperty['通道'] = item.value;
                      }
                    }
                  }
                  ///////////////////////////////////////////
                }
              }
              for (let m in this.parameter) {
                //if (formproperty.hasOwnProperty(this.parameter[m].name)) {
                formproperty[this.parameter[m].name] = this.parameter[m].value;
                //}
              }

              var hasValue = false;
              if (packagesize) {
                var x = parseFloat(packagesize.X);
                var y = parseFloat(packagesize.Y)
                for (let m in this.BookContent) {
                  if (this.BookContent[m].seedcode == seedcode) {
                    for (let k in this.BookContent[m].book) {
                      if (parseFloat(this.BookContent[m].book[k].X) == x && parseFloat(this.BookContent[m].book[k].Y) == y) {
                        hasValue = true;
                        break;
                      }
                    }
                  }
                }

                if (!hasValue) {
                  this.$message({
                    message: '光度（' + packagesize.Y + '，' + packagesize.X + '）超范围！',
                    type: 'error',
                  })
                  return;
                }
              }

              var propitem = {};
              for (let key in formproperty) {
                if (key == '总瞳距' || key == '右瞳距' || key == '左瞳距' || key == '右眼瞳高' || key == '左眼瞳高' || key == '矫正视力') {
                  continue;
                }
                if (formproperty[key])
                  propitem[key] = formproperty[key];
              }

              updateArr.push({
                unitguid: unitguid,
                packagesize: JSON.stringify(packagesize),
                formproperty: '[' + JSON.stringify(propitem) + ']'
              })

              break;
            }
          }
        }

        updatePackagesize({arr: JSON.stringify(updateArr)}).then(response => {
          this.dialogFormVisible = false
          this.$emit("reflashInit")
        })
      },
      saveDataframe(){
        var arr=[];
        for(let i in  this.DataTable) {
          if (this.DataTable[i]["数量"] > 0) {
            arr.push(this.DataTable[i])
          }
        }
        if(arr.length==0){
          this.$message({
            message: '缺少产品！',
            type: 'warning'
          })
          return;
        }

        updateGoodsnum({erpserial:this.erpserial,arr: JSON.stringify(arr)}).then(response => {
          this.dialogFormVisible = false
          this.$emit("reflashInit")
        })
      },
      show(controlData, goodsDetail, parameter) {
        this.noAdd = true;
        this.noTongD = true;
        this.noRL = true;
        this.canEditRL = false;
        this.DataTable = [];
        this.erpserial=controlData.erpserial;
        var colums = '';

        this.isframe = false;
        for (let i in goodsDetail) {
          if (goodsDetail[i]["规格"]) {
            this.isframe = true;
            break;
          }
        }
        if (this.isframe) {//修改镜架
          this.showFrame(controlData, goodsDetail, parameter);
          return;
        }

        for (let i in goodsDetail) {
          var arr = [];
          var hasPackage = false;
          for (let j in goodsDetail[i]) {
            var show = 0;
            if (j == "ADD")
              this.noAdd = false;
            if (j == "通道")
              this.noTongD = false;
            if (j == "R/L")
              this.noRL = false;

            if (j == "unitguid" || j == "是否坏件" || j == "formproperty" || j == "关联产品" || j == "subseedcode" || j == "说明" || j == "单价" || j == "总价" || j == "销售单号") {

            } else if (j == "packagesize") {
              hasPackage = goodsDetail[i][j] ? true : false;
            } else if (j == "seedcode" || j == "产品名称" || j == "数量") {
              show = 1;
            } else {
              show = 2;
            }
            var nameS = j;
            if (nameS == "seedcode") {
              nameS = '产品编码'
            }
            arr.push({name: nameS, value: goodsDetail[i][j], isshow: show})
          }
          if (hasPackage) {
            if (this.noRL) {
              arr.push({name: "R/L", value: "", isshow: 2})
            }
            if (this.noAdd) {
              arr.push({name: "ADD", value: "", isshow: 2})
            }
            if (this.noTongD) {
              arr.push({name: "通道", value: "", isshow: 2})
            }
          }
          this.DataTable.push(arr)
        }
        this.parameter = []

        this.parameter.push({name: '瞳高', value: ''})
        this.parameter.push({name: '瞳距', value: ''})
        this.parameter.push({name: '右眼瞳距', value: ''})
        this.parameter.push({name: '左眼瞳距', value: ''})
        this.parameter.push({name: '镜宽', value: ''})
        this.parameter.push({name: '梁宽', value: ''})
        this.parameter.push({name: '镜高', value: ''})

        for (let j in parameter) {
          if (j == '瞳高' || j == '瞳距' || j == '右眼瞳距' || j == '左眼瞳距' || j == '镜宽' || j == '梁宽' || j == '镜高') {
            for (let m in this.parameter) {
              if (this.parameter[m].name == j)
                this.parameter[m].value = parameter[j]
            }
          } else if (j == '右瞳距') {
            for (let m in this.parameter) {
              if (this.parameter[m].name == '右眼瞳距')
                this.parameter[m].value = parameter[j]
            }
          } else if (j == '左瞳距') {
            for (let m in this.parameter) {
              if (this.parameter[m].name == '左眼瞳距')
                this.parameter[m].value = parameter[j]
            }
          } else if (j == '总瞳距') {
            for (let m in this.parameter) {
              if (this.parameter[m].name == '瞳距')
                this.parameter[m].value = parameter[j]
            }
          } else if (j == '右眼瞳高' || j == '左眼瞳高' || j == '矫正视力' || j.indexOf('优化') > -1) {//不需要

          } else {
            this.parameter.push({name: j, value: parameter[j]})
          }
        }

        //商品明细
        getJxcformdetailGetList({erpserial: this.erpserial}).then(response => {
          this.details = response.data.obj

          var seedlist = ';'
          for (let i in this.details) {
            if (this.details[i].packagesize) {//镜片
              var hasValue = false;
              for (let m in this.BookContent) {
                if (this.BookContent[m].seedcode == this.details[i].seedcode) {
                  hasValue = true
                }
              }
              if (seedlist.indexOf(';' + this.details[i].seedcode + ';') > -1)
                hasValue = true;
              seedlist += this.details[i].seedcode + ';'

              if (!hasValue) {
                getPrice({seedcode: this.details[i].seedcode}).then(resBook => {
                  this.BookContent.push({seedcode: this.details[i].seedcode, book: resBook.data.obj.BookContent})
                })
              }
            }
          }
        })

        this.dialogFormVisible = true;
      },
      showFrame(controlData, goodsDetail, parameter) {
        if (controlData.paymethod != '按合同结算') {
          alert('月结订单才允许修改商品！');
          this.dialogFormVisible = false;
          return;
        }
        //根据登录人过滤仓库
        cusandptbyind({}).then(response => {
          this.jxcstoreData = response.data.obj;
          this.cangkucode = this.jxcstoreData[0].cangkucode;
          this.changeCangKu();
        })
        for (let i in goodsDetail) {
          this.DataTable.push(goodsDetail[i])
        }
        this.subTable();
        this.parameter = []
        this.dialogFormVisible = true;
      },
    },
    mounted() {
    }
    ,
    components: {
      BatchBuyFormProperties,
      MakeInventoryFrameAdd
    }
  }
</script>

<style scoped>
  .query-table td {
    border: 1px solid #E0DFDF;
    vertical-align: center;
    height: 22px;
    line-height: 16px;
    padding: 2px;
    font-size: 12px;
  }

  .query-table td.content {
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/testorder/cstagreement/editPackage.vue